import React from 'react';
import { motion } from 'framer-motion';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiMail, FiMousePointer } = FiIcons;

const EmailMarketing = ({ client, data }) => {
  const safeData = data || {
    listSize: 0, emailsSent: 0, openRate: 0, clickRate: 0, campaigns: []
  };

  const metrics = [
    { title: 'List Size', value: safeData.listSize, icon: FiMail, color: 'text-blue-600' },
    { title: 'Emails Sent', value: safeData.emailsSent, icon: FiMail, color: 'text-purple-600' },
    { title: 'Open Rate', value: `${safeData.openRate}%`, icon: FiMail, color: 'text-green-600' },
    { title: 'Click Rate', value: `${safeData.clickRate}%`, icon: FiMousePointer, color: 'text-orange-600' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-gray-800 mb-2">Email Marketing</h2>
        <p className="text-gray-600">Campaign performance summary</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {metrics.map((metric, index) => (
          <motion.div
            key={metric.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
          >
            <div className="flex items-center justify-between mb-4">
              <div className={`w-10 h-10 rounded-lg bg-opacity-10 flex items-center justify-center ${metric.color.replace('text-', 'bg-')}`}>
                <SafeIcon icon={metric.icon} className={`text-lg ${metric.color}`} />
              </div>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-1">{metric.value}</h3>
            <p className="text-sm text-gray-600">{metric.title}</p>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
      >
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Campaign Performance</h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-3 px-4 font-medium text-gray-600">Campaign</th>
                <th className="text-right py-3 px-4 font-medium text-gray-600">Sent</th>
                <th className="text-right py-3 px-4 font-medium text-gray-600">Open Rate</th>
              </tr>
            </thead>
            <tbody>
              {safeData.campaigns && safeData.campaigns.map((camp, index) => (
                <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="py-4 px-4 font-medium text-gray-800">{camp.name}</td>
                  <td className="py-4 px-4 text-right text-gray-600">{camp.sent}</td>
                  <td className="py-4 px-4 text-right text-gray-600">{camp.openRate}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </motion.div>
    </div>
  );
};

export default EmailMarketing;